const Form013TC = {
    stepName: {
        importantNotes: "重要事項",
        proposedProjectDistrict: "推行計劃的區域",
        ngoParticular: "申請機構資料",
        ngoDeclaration: "申請機構聲明",
        departmentParticular: "推行計劃的部門／單位／附屬機構資料",
        coordinatorParticular: "計劃統籌員／聯絡人資料",
        schoolDeclaration: "協作學校聲明",
        proposedProject: "申請計劃資料",
        noOfEligibleStudent: "參與協作學校和／或中心活動的合資格學生人數預算",
        activityDetail: "建議活動資料",
        projectIncomeAndExpend: "整項計劃的收入及開支預算",
        confirmation: "確認",
        formA: "上載機構／協作學校表格",
        formB: "推行計劃的部門／單位／附屬機構資料",
        formExpired: "重要事項",
    },
    header: {
        note: "重要事項",
        partA: "A部：推行計劃的地區（每份申請表只可申請在一個地區推行計劃，擬在多於一個地區推行計劃應另紙申請）",
        partB: "B部：申請機構資料",
        partC: "C部：申請機構聲明",
        partD1: "D1部：推行計劃的<u>部門／單位</u>資料（由申請機構直接負責推行計劃，請填寫D1部）",
        partD2: "D2部：獲授權推行計劃的<u>附屬</u>機構資料（由獲授權推行計劃的附屬機構負責推行計劃，請填寫D2部）",
        partE: "E部：計劃統籌員／聯絡人資料",
        partF: "本計劃是否涉及協作學校？",
        partF1: "F1部：協作學校聲明",
        partF2: "F2部：協作學校聲明",
        partG: "G部：申請計劃資料",
        partH: "H部：機構／協作學校舉辦的各項活動的預算受惠合資格學生參加人數",
        partI: "I部︰計劃的分項活動詳情",
        partJ: "J部︰整項計劃的收入及開支預算",
        partK: "K部︰其他相關的附加資料（如有）",
    },
    label: {
        // Part A
        hkRegion: "港島區",
        klRegion: "九龍區",
        nteRegion: "新界東區",
        ntwRegion: "新界西區",
        // Part B
        english: "（英文）",
        chinese: "（中文）",
        ngoName: "機構名稱",
        ngoCode: "機構編號",
        ngoHeadName: "機構負責人姓名",
        ngoHeadTitle: "稱謂",
        ngoHeadPost: "職位（如主席／行政總裁／總幹事）",
        ngoAddress: "機構地址",
        ngoTelNo: "機構電話號碼",
        ngoEmail: "機構電郵地址",
        ngoWebsite: "機構網址",
        ngoMission: "機構成立宗旨",
        majorArea: "機構主要提供的服務",
        incomeSource: "機構的經費來源",
        experienceDesc: "機構曾為合資格學生提供服務的經驗：",
        cbpExperience: "過往推行區本計劃的經驗︰",
        otherExperience:
            "機構於過去5年舉辦相關課後活動的經驗︰（如協辦校本津貼資助的計劃或其他計劃）",
        schoolYear: "學年",
        projectCode: "計劃編號",
        collaboratingSchoolName: "協作學校名稱",
        // Part C
        c1: "本人代表（申請機構：<u>&emsp;{{name}}&emsp;</u>）謹此聲明：",
        c1a: "本機構屬持有《稅務條例》（第112章）第88條獲認可為公共性質的慈善機構或信託團體；主要從事社福工作。",
        // c1bi1: "本申請表建議計劃將由本機構直接負責推行。推行部門／單位的資料見D1部，負責的統籌員資料見E部。",
        c1bi1: "如申請計劃獲批撥款，有關計劃將由本機構直接負責推行。推行部門／單位的資料見D1部，負責的計劃統籌員資料見E部。",
        // c1bi2: "推行部門／單位名稱：",
        c1bi2: "推行部門／單位名稱",
        c1bii1: "如申請計劃獲批撥款，本機構將授權<b>附屬</b>機構(附屬機構名稱)",
        c1bii2: "推行本申請表建議計劃。本人明白獲批計劃雖然由該附屬機構全權推行，本機構仍須按校本課後學習及支援計劃受款人協議書第9.4條<b>負上最終責任</b>。附屬機構的資料見D2部，負責計劃的計劃統籌員資料見E部。",
        c1bii3: "<b>［已夾附以上(b)(i)及／或(ii)的相關證明文件。］</b>",
        c1biii: "本申請表建議計劃將由本機構直接負責推行，負責計劃的統籌員資料見 E部。",
        c1c: "申請計劃並沒有與獲其他機構為社區／學校推行的資助計劃重複。",
        c1d: "本人證明本申請表格填寫的資料均屬真確無訛。本人明白如蓄意虛報資料或隱瞞任何重要資料，申請即告無效。所有獲批撥款將被扣發，已獲發放的款項亦須退還教育局，本人代表的機構亦需就此負上最終責任。",
        c1e: "本人同意教育局可使用本申請表格的資料審批申請、進行研究、評估計劃及舉辦訓練／分享會。",
        c1f: "如申請計劃獲批撥款資助，本人承諾會積極參與計劃的所有推廣、推介及宣傳活動。",
        c1g: "有需要時，教育局有權要求本機構提供與附屬機構的從屬關係證明。",
        post: "機構負責人職位",
        ngoChop: "機構印鑑",
        sectionName: "推行部門／單位名稱",
        subsidiaryOrganisation: "附屬機構",
        // Part D
        partD1: "部門／單位",
        partD2: "附屬機構",
        departmentName: "{{name}}名稱",
        departmentHeadName: "{{name}}負責人姓名及職位",
        departmentHeadTitle: "稱謂",
        departmentHeadPost: "職位",
        departmentAddress: "{{name}}地址",
        departmentTelNo: "{{name}}電話號碼",
        departmentFaxNo: "{{name}}傳真號碼",
        departmentEmail: "{{name}}電郵地址",
        departmentWebsite: "{{name}}網址",
        departmentChop: "{{name}}印鑑",
        // Part E
        partD1Choice:
            "根據校本課後學習及支援計劃受款人協議第9.1節，申請機構指派的計劃統籌員資料如下：",
        partD2Choice:
            "根據校本課後學習及支援計劃受款人協議第9.1節，獲授權推行計劃的附屬機構指派的計劃統籌員資料如下：",
        partD1OrgName: "負責推行計劃的<u><b>部門／單位</b></u>名稱：",
        partD2OrgName: "授權推行計劃的<b><u>附屬</u>機構</b>名稱：",
        coordinatorPost: "計劃統籌員職位",
        coordinatorName: "計劃統籌員中文姓名",
        coordinatorTitle: "稱謂",
        coordinatorContact: "計劃統籌員的聯絡方法：",
        coordinatorTelNo: "機構電話號碼",
        coordinatorMobile: "緊急聯絡電話號碼",
        coordinatorFaxNo: "傳真號碼",
        coordinatorEmail: "電郵地址",
        contactPersonName: "聯絡人（計劃統籌員以外的人員）中文姓名",
        contactPersonTitle: "稱謂",
        contactPersonPost: "聯絡人職位",
        contactPersonContact: "聯絡人的聯絡方法：",
        contactPersonTelNo: "機構電話號碼",
        contactPersonMobile: "緊急聯絡電話號碼",
        contactPersonEmail: "電郵地址",
        note: "注意：",
        noteE1: "負責執行計劃的計劃統籌員，不論管理計劃數目多寡，其負責的所有計劃撥款總額上限不能超逾港幣{{budgetLimitCh}}元。",
        noteE2: "計劃統籌員代表機構或獲授權推行計劃的附屬機構全權負責計劃的整體管理，機構需確保計劃統籌員及聯絡人的聯絡資料正確，以便教育局可適時聯絡相關人員。",
        ngoSchool: "協作學校",
        ngoSchoolName: "學校名稱",
        ngoSchoolSame: "學校與機構是否於{{lastYear}}學年合作推行區本計劃？",

        // Part F
        partF1Note:
            "本部份只適用於學校與機構於2020/21學年已合作推行區本計劃，並於2021/22學年<b><u>繼續協作的計劃</u></b>。（若雙方於2020/21學年<u>並無</u>合作推行計劃，請填寫<b><u>F2</u></b>部。）學校數目並無限制，但只限同一區內的學校參與。",
        partF2Note:
            "本部份只適用於學校與機構並<b><u>沒有於2020/21學年協作</u></b>推行區本計劃。（若雙方已於2020/21學年協作推行區本計劃，請填寫F1部）<br/>學校數目並無限制，但只限同一區內的學校參與。",
        f1: "此部份由學校填寫：",
        f2: "此部份由{{name}}填寫：",
        f21: "本校已與協作機構就計劃的行政安排達成共識，於F2部（3）詳列有關協議內容，並由學校的負責老師及機構的計劃統籌員簽署作實。",
        f22: "本機構已與學校就計劃的行政安排達成共識，於F2部（3）詳列有關協議內容，並由學校的負責老師及機構的計劃統籌員簽署作實。",
        f3: "學校與申請機構面談記錄（學校與機構達成下列共識後填寫，並簽署作實）",
        f31: "（請在橫線上填寫雙方議定的內容，並在適用的☐內加上「✓」號；可選多於一項。）",
        f3a: "學校與機構透過以下途徑商討有關「區本計劃」各項活動細節及內容，並就各項內容達成共識。</br>（詳見本申請表I部）",
        f3b1: "機構須於活動開展前",
        f3b2: "個工作天內，向學校提交以下文件，以供學校查閱：",
        f3c: "機構須確保所聘請的導師（包括代課導師）已通過「性罪行定罪紀錄查核」。",
        f3d1: "如學校欲修訂已批核的「區本計劃」各項活動細節或內容，須於擬活動舉辦日期的 ",
        f3d2: " 個工作天前通知機構；機構在接獲有關要求後，須於 ",
        f3d3: " 個工作天內以書面向教育局提交修訂申請。",
        f3e1: "如學校對「區本計劃」的內容或進度有任何垂詢，機構須於 ",
        f3e2: " 個工作天內向學校作出口頭回覆，並在有需要時以書面向學校提交相關資料。",
        f3f1: "如機構更換「區本計劃」的計劃統籌員，機構須於 ",
        f3f2: " 個工作天內透過電話或書面通知學校有關安排。",
        f3g: "如學校或機構需安排轉換導師，雙方的安排及跟進如下：",
        f3g1: "立即通知對方。機構須於 ",
        f3g2: " 個工作天內完成有關安排，並向學校提交上述（b）項中所列的相關文件，以便學校跟進及存檔。",
        f3h: "如有導師出缺，機構須負責安排代課導師，有關程序及細節如下：",
        f3h1: "機構須於活動開展前 ",
        f3h2: " 小時通知學校有關安排，並於 ",
        f3h3: " 工作天內向學校提交上述（b）項中所列的相關文件，以便學校跟進及存檔。",
        schoolName: "學校名稱",
        schoolAddress: "學校地址",
        schoolCode: "學校編號",
        session: "授課時間",
        schoolType: "學校類別",
        schoolLevel: "學校級別",
        numOfStudent: "合資格學生人數",
        numOfStudent1: "預算<u>參與</u>本計劃的<u>合資格學生</u>",
        numOfStudent2: "人數（以人頭計算）",
        numOfStudent3: "名（當中包括約",
        numOfStudent4: "名非華語學生、",
        numOfStudent5: "名特殊教育需要學生及",
        numOfStudent6: "名新來港學童）。",
        numOfNCS: "非華語學生人數",
        numOfSEN: "特殊教育需要學生人數",
        numOfNAC: "新來港學童人數",
        teacherName: "學校負責老師姓名",
        teacherPost: "職位",
        schoolHead: "校監／校長",
        schoolHeadName: "{{name}}姓名",
        schoolTel: "學校電話號碼",
        schoolFax: "學校傳真號碼",
        schoolEmail: "電郵",
        schoolChop: "學校印鑑",
        partD1Ngo: "機構",
        partD2Ngo: "機構附屬機構",
        ngo: "機構／附屬機構",
        organisationName: "{{name}}名稱",
        organisationChop: "{{name}}印鑑",
        wayToDiscuss: "商討途徑",
        otherDocument: "其他文件",
        otherArrangement: "其他安排",
        workingDay: "工作日",
        workingHour: "時間",
        other: "其他",
        // Part G
        g4a: "預算<u>協作學校</u>受惠的合資格學生總數(以人頭計算)：",
        g4a1: "（",
        g4a2: " 名）",
        g4b: "預算<u>服務整個地區</u>的項目的受惠的合資格學生總數(以人頭計算)：",
        g4b1: "（小學：",
        g4b2: " 名 + 中學：",
        g4b3: " 名 = <u>&emsp;{{num}}&emsp;</u> 名<sup>#</sup>）",
        g4b4: "＃當中包括以下類別學生：",
        g4ab: "共 <u>&emsp;{{num}}&emsp;</u> 名",
        projectTitle: "計劃名稱",
        commencementDate: "開始日期",
        completionDate: "結束日期",
        projectObjective: "計劃目標",
        evaluationMethod: "評估方法",
        NCS: "（i）非華語學生：",
        SEN: "（ii）特殊教育需要學生：",
        NAC: "（ii）新來港學童：",
        primary: "小學",
        secondary: "中學",
        total: "總計（人頭）",
        // Part H
        totalByActivity: "每項活動的預計參加合資格學生總數",
        totalBySchool: "總數（即參加上述活動的學生總人次）",
        // Part I
        priority: "可填寫優先次序",
        edbPriority: "供教育局填寫優先次序",
        activityNature: "活動性質",
        activityName: "活動名稱",
        activitySchool: "協作學校名稱（如適用）",
        activityContent: "請簡述活動目的及內容",
        objectiveContent: "活動目的及內容",
        activityType: "活動種類",
        i5a1: "估計受惠合資格學生人數（人頭）：",
        i5a2: " 名<sup>#</sup>（當中包括 ",
        i5a3: " 名非華語學生、",
        i5a4: " 名特殊教育需要學生及 ",
        i5a5: " 名新來港學童）。",
        i5b1: "＃如服務整個地區（見第3點）或與特殊學校協作，請分別填寫預計包括：",
        i5b2: " 名小學生（當中包括 ",
        i5b3: " 名非華語學生、 ",
        i5b4: " 名特殊教育需要學生及 ",
        i5b5: " 名新來港學童）及／或 ",
        i5b6: " 名中學生（當中包括 ",
        i5b7: " 名新來港學童）。",
        i61: "估計自費參加活動的非合資格學生人數",
        i62: "（人頭）：",
        i63: " 名（如適用）",
        i101: "每組全年共 ",
        i102: " 節，每節 ",
        i9: "每組活動包括：",
        i10: "開支項目",
        i11: "總開支（甲）",
        i12: "收入項目",
        i13: "總收入（乙）",
        i14: "申請津貼額（甲 — 乙）",
        date: "日期：",
        from: "由",
        to: "至",
        time: "時間",
        timeNote: "（請以「✓」選出適用時段）",
        numOfGroup: "組別數目",
        studentRatio: "，每組導師：學生比例為",
        ratio: "導師：學生比例",
        classVenue: "上課地點",
        numOfSession: "課堂",
        numOfHour: "每節",
        halfDay: "半日活動",
        wholeDay: "全日活動",
        venue: "地點",
        district: "地區",
        budget: "建議活動的預算項目：",
        instructor: "導師",
        assistant: "教學助理",
        remuneration: "薪金：",
        academic: "預算聘請導師學歷",
        reason: "請註明身份及聘請原因",
        stateReason: "身份及聘請原因",
        socialWorker: "社工：",
        otherStaff: "其他：",
        material: "活動物資",
        specify: "請註明",
        campFee: "營費／入場費：",
        mealFee: "學生膳食：",
        trafficFee: "活動交通費：",
        numOfMinibus: "小巴數目",
        numOfCoach: "大巴數目",
        volunteerAllowance: "義工津貼：",
        numOfVolunteer: "請註明",
        totalAttendance: "出席總次數",
        nonEligibleFee: "非合資格學生活動收費",
        name: "姓名",
        confirmedBy: "由協作學校確認：",
        // Part J
        projectExpend: "計劃活動的開支預算（甲）：",
        administrationCost: "行政費用預算（乙）",
        coordinationCost: "計劃統籌費用預算（丙）",
        projectIncome: "預算總收入（丁）：",
        totalAmount: "申請撥款總額（甲 ＋ 乙 ＋ 丙 — 丁）：",
        // Part K
        otherInformation: "其他相關的附加資料",
        partKAtt1:
            "曾參與區本計劃的申請機構：證明機構及其授權推行計劃的附屬機構（如適用）為已根據《內務條例》（第 112章）第 88條獲認可為公共性質的慈善機構或信託團體的文件。",
        partK2: "首次申請機構: 公司章程、機構憲章或社團會章已更改的機構：證明機構為已根據《內務條例》（第 112章）第 88條獲認可為公共性質的慈善機構或信託團體的文件。根據《公司條例》（第32章）註冊為有限公司所需的公司章程或根據《社團條例》（第 151章）註冊的機構憲章或社團會章。",
        partKAtt2:
            "證明機構可於非協作學校內的地點進行非正規課程的學校註冊證明書（副本），或已填妥根據《教育條例》（第279章），條例第 9(5)條提交的豁免學校註冊申請書。",

        num: "數字",
        int: "整數",
        colon: '：<span class="danger">*</span>',
        statement: "本人已閱讀、明白及同意上述條款及細則",
        note1: "電子表格所載的資料均以教育局網頁上之表格為準",
        note10: "https://www.edb.gov.hk/tc/student-parents/support-subsidies/after-sch-learning-support-program/community-based-projects/index.html",
        note2: "申請須知︰",
        note20: "在填寫申請表之前，請詳閱校本課後學習及支援計劃-區本計劃指引。",
        note21: "區本計劃（計劃）只供非牟利非政府機構（機構）申請。",
        note22: "申請機構（包括獲授權推行計劃的附屬機構）必須為已根據《稅務條例》（第112章）第88條獲認可為公共性質的慈善機構或信託團體，其公司章程、機構憲章或社團會章內有關成立目標應包括提供與社福相關的服務。為簡化程序，曾申請計劃並獲批的申請機構（包括獲授權推行計劃的附屬機構）除非更改公司章程、機構憲章或社團會章，否則只須遞交獲認可為公共性質的慈善機構或信託團體的證明文件；惟若有需要，教育局會要求申請機構遞交詳細文件。而首次申請計劃的機構則必須在申請表格內夾附上述證明文件相關部份的副本一份。",
        note23: "即使申請表中有任何相反的規定，教育局保留以申請機構曾經、正在或有理由相信申請機構曾經或正在作出可能構成或導致發生危害國家安全罪行的行為或活動為由，取消其申請資格的權利，又或為維護國家安全，或為保障香港的公眾利益、公共道德、公共秩序或公共安全，而有必要剔除有關申請機構。",
        note24: "申請機構必須使用{{schoolYear}}學年的申請表，否則恕不受理。請勿自行更改本申請表的格式或內容，惟機構可以附件形式詳列有關資料。",
        note25: "申請的計劃可補足但不應取代或重複獲其他機構撥款資助的計劃（如全方位學習津貼、民政事務總署撥款和社會福利署下資助計劃等）。",
        note26: "計劃只資助合資格學生［即領取綜合社會保障援助（綜援）及學生資助計劃全額津貼的小一至中六學生］。若計劃與學校協作，受惠學生亦可包括由協作學校使用酌情名額界定為清貧的學生。",
        note27: "若申請的計劃與學校協作，申請機構與協作學校必須另行填寫在電子表格內下載的PDF表格中的F1或F2部的協作學校資料。若申請機構與協作學校已於{{lastYear}}學年協作推行區本計劃，並於{{schoolYear}}學年繼續協作申請計劃，請填寫F1部；申請機構於{{schoolYear}}學年開始與協作學校協作推行計劃，請填寫F2部，以證明申請機構與協作學校在遞交申請前有良好及充足溝通，確保雙方在計劃詳情（如協作學校的需求、活動安排及導師條件，包括性罪行定罪紀錄查核等）已達成共識，使計劃能於日後順利推行。此外，申請機構亦須請協作學校核實Ｉ部計劃的分項活動詳情，並在PDF表格上的相關部份簽名及蓋印。在遞交電子表格後，申請機構須將已填妥的申請表格F部及I部的正本，於截止申請日期或以前郵寄或親身遞交至教育局學生特別支援組（地址︰香港灣仔皇后大道東213號胡忠大廈11樓1141室）。若機構透過郵寄方式遞交申請表格，請以掛號形式投遞，以確保申請表格能成功送達。郵寄申請以郵戳日期為準。<b>以傳真或電郵方式遞交的申請表格，恕不受理。</b>所有已遞交的文件概不退還。",
        note28: "申請機構若於非協作學校內開辦非正規課程（如功課輔導、學習技巧訓練及語文訓練），或在協作學校開辦的非正規課程包括其他學校的學生，其上課地點必須符合《教育條例》的規定。請夾附有關文件（如已備有學校註冊證明書或根據教育條例（第279章）第9(5)條提出申請豁免學校註冊的申請書）於申請時一併遞交。",
        note29: "計劃由{{startYear}}年2月25日起接受申請，截止日期為<b><u>{{startYear}}年3月28日</u></b>。逾期提交的申請一般不會受理，然而校本課後學習及支援計劃委員會（委員會）會就符合以下條件的逾期申請作個別考慮：<ul><li>申請計劃為一項由機構與學校協作推行的計劃；以及</li><li>機構於截止日期起計不遲於15個工作天內提交申請及以書面解釋逾期提交申請的原因，並提供協作學校的相關証明文件以作支持。</li>有關上述逾期申請的處理，委員會亦會就機構過往提交申請的情況作考慮。",
        note210:
            "每個計劃的申請撥款總額上限為港幣{{budgetLimitCh}}元。同時，負責執行計劃的計劃統籌員，不論管理計劃數目多寡，其負責的所有計劃撥款總額上限亦不能超逾港幣{{budgetLimitCh}}元。",
        note211: "計劃一經批核，有關協作學校會獲通知獲批撥款額及活動內容。",
        note3: "有關收集個人資料聲明",
        note30a: "收集目的",
        note30: "本申請表所填報的個人資料，是供教育局作審批校本課後學習及支援計劃之用。申請如獲批准，這些個人資料亦將會妥善用作監察、推廣、宣傳及推介計劃用途。",
        note31: "本申請表所填報的個人資料，純屬自願提供性質。如未能提供這些資料，可能會影響申請的評審和結果。",
        note32a: "披露及查閱個人資料",
        note32: "如有需要，教育局或會把本申請表所載的個人資料，向校本課後學習及支援計劃委員會、其他政府部門、外聘監察員、監察計劃委員及其他有關人士披露。",
        note33: "根據《個人資料(私隱)條例》第18及22條，以及附表1第6原則的規定，填報本表格的申請人有權查閱及更正所提供的個人資料，包括索取表格內有關個人資料部分的副本。",
        note34a: "查詢",
        note34: "如對本申請表所須填報的個人資料有任何查詢，包括查閱及更正資料，請與教育局學生特別支援組聯絡：",
        noteAddress: "地址︰",
        noteTel: "電話︰",
        noteFax: "傳真︰",
        note40Txt: "地址︰",
        note40Val:
            "香港灣仔<br/>皇后大道東213號<br/>胡忠大廈11樓1141室<br/>教育局<br/>學生特別支援組",
        note41Txt: "電話︰",
        note41Val: "2892 6659",
        note42Txt: "傳真︰",
        note42Val: "3107 1306",
        editNote: "備註:",
        editNoteContent:
            "若審核人需要修改電子表格的內容，請將此表格發還給申請人修改。",
        nameOfSO: "部門／單位名稱",
        nameOfHSO: "部門／單位負責人姓名",
        addressOfSO: "部門／單位地址",
    },
    tooltip: {
        ngoCode: "只適用於曾參與{{lastYear}}學年計劃的機構",
        schoolType: "特殊學校中、小學部需分開表格填寫",
        numOfStudent: "請學校參考2020/21學年『區本計劃』實際參與人數作出預算。",
        eligibleStudent:
            "合資格學生 — 即領取綜援及學生資助計劃全額津貼的小一至中六學生及學校使用酌情權提供的清貧學生。",
        coordinatorName: "此欄須與E部計劃統籌員中文姓名一致。",
        completionDate: "所有計劃必須於{{endYear}}年7月31日或以前完成。",
        activitySchool:
            "每張活動分項表只應填寫一間協校／舉辦中心，如申請計劃包括多於一間協校／舉辦中心，請自行影印。",
        activityType: {
            b1: "只填寫一個種類，如音樂、手工藝。如每組節數不同，請詳細列明。",
            b3: "只填寫一個種類，如球類、游泳。如每組節數不同，請詳細列明。",
        },
        numOfNonEligibleStudent:
            "非合資格學生 ─ 自費參加活動的學生。參加學生必須繳付全費。",
        time: "為使學生有機會參與其他活動，功課輔導的時數上限為每星期4.5小時",
        numOfGroup: "組別數目等同於聘請導師人數",
        venue: "機構若於非協作學校內開辦非正規課程（如功課輔導、學習技巧訓練及語文訓練），或在協作學校開辦的非正規課程包括其他學校的學生，則上課地點必須符合《教育條例》的規定，請夾附有關文件（如學校註冊證明書（副本）或已填妥的豁免學校註冊申請書）於申請時一併遞交",
        halfDay: "不少於四小時",
        wholeDay: "不少於七小時",
        cost: "有關行政費的開支，請填寫在J部（2）",
        item: "若實際參與學生數目低於批核人數，機構須按比例減少組別數目及所有項目的開支",
        instructor: "有關計劃聘請導師的資歷要求請參閱「區本計劃指引」",
        assistant: "教學助理負責於該項活動推行期間提供協助",
        mealFee: "只限全日活動",
        trafficFee: "只限戶外活動或營會活動",
        projectExpend: "所有I部活動的總開支",
        administrationCost: "申請的行政費用預算必須為整數",
        coordinationCost: "申請的計劃統籌費用預算必須為整數",
        projectIncome: "所有I部活動的總收入",
        totalAmount: "每個計劃的申請撥款總額上限為港幣{{budgetLimitCh}}元",
    },
    unit: {
        s: "節",
        hps: "小時",
        t: "次",
        d: "日",
        h: "（時薪）",
        $: "（$）",
        "h/s": "小時",
        ss: "節",
        g: "組",
        ps: "（每節）",
        pg: "（每組）",
        p: "人",
        stu: "學生",
    },
    doc: {
        1: "導師名單",
        2: "導師資歷證明",
        3: "導師「性罪行定罪紀錄查核」參考編號",
        4: "與導師簽訂的合約",
        5: "其他（如有，請註明）：",
    },
    districtObj: {
        hkRegion: {
            cw: "中西區",
            hke: "東區",
            is: "離島",
            so: "南區",
            wc: "灣仔",
        },
        klRegion: {
            klc: "九龍城",
            kt: "觀塘",
            sk: "西貢",
            ssp: "深水埗",
            wts: "黃大仙",
            ytm: "油尖旺",
        },
        nteRegion: {
            no: "北區",
            st: "沙田",
            tp: "大埔",
        },
        ntwRegion: {
            kc: "葵青",
            tw: "荃灣",
            tm: "屯門",
            yl: "元朗",
        },
    },
    titleObj: {
        mr: "先生",
        mrs: "女士",
        miss: "太太",
        ms: "小姐",
    },
    sessionObj: {
        am: "上午",
        pm: "下午",
        wd: "全日",
    },
    schoolTypeObj: {
        govt: "官立",
        aided: "資助",
        caput: "按位津貼",
        dss: "直接資助",
        private: "私立",
        special: "特殊學校",
    },
    schoolLevelObj: {
        sec: "中學",
        pri: "小學",
    },
    schoolHeadObj: {
        supervisor: "校監",
        principal: "校長",
    },
    wayToDiscussObj: {
        interview: "面談",
        phone: "電話",
        email: "電郵",
        fax: "傳真",
        other: "其他",
    },
    activityObj: {
        a1: "A1：功課輔導",
        a2: "A2：學習技巧訓練",
        a3: "A3：語文訓練",
        b1: "B1：文化藝術",
        b2: "B2：參觀／戶外活動",
        b3: "B3：體育活動",
        c1: "C1：義工服務",
        c2: "C2：自信心訓練",
        c3: "C3：社交／溝通技巧訓練",
        c4: "C4：歷奇活動",
        c5: "C5：領袖訓練",
    },
    collaborateObj: {
        single: "活動只與一間協作學校合辦",
        alone: "服務整個地區，沒有與任何學校協辦",
    },
    timeObj: {
        afterSchool: "星期一至五 課後至下午六時",
        saturday: "星期六 ",
        after6pm: "星期一至五 下午六時以後",
        holiday: "假日 ",
    },
    ampmObj: {
        am: "早上",
        pm: "下午",
    },
    academicObj: {
        secondary5:
            "中五畢業（香港中學會考五科合格，包括中、英（課程乙）、數三科）或中六畢業（香港中學文憑考試五科2級，包括中、英、數三科",
        secondary6:
            "中六畢業（香港中學文憑考試五科3級，包括中、英、數三科）或中七畢業（高級程度會考中英及2AL／1AL+2AS合格）",
        secondaryGrad: "大專畢業（高級文憑／副學士）",
        uGrad: "大學畢業",
        chiMajorGrad: "大學畢業（主修中文）",
        engMajorGrad: "大學畢業（主修英文）",
        mathMajorGrad: "大學畢業（主修數學）",
    },
    postObj: {
        principal: "校長",
        teacher: "負責老師",
    },
    errorMsg: {
        totalErr: "學生總人數不應超過5000人",
        fromDateErr: "此日期應在完結日期之前",
        toDateErr: "此日期應在開始日期之後",
    },
    FormA: {
        title: "F部：協作學校聲明",
        schoolName: "學校名稱",
        scrn: "學校編號",
        formType: "表格類別",
        type: "{{formType}}部：協作學校聲明",
        typeF1: "（適用於繼續與上學年合作機構協作的學校）",
        typeF2: "（適用於上學年並非與機構協作的學校）",
        uploadFile: "上載表格",

        // added for new workflow
        partD: "D部：推行計劃的部門／機構資料",
        subsidiaryOrganisation: "推行計劃的機構",
        orgId: "機構編號",
        uploadedForm: "上載表格",
        partD2: "D2部：推行計劃的附屬機構資料",
        uploadInstruction: "請上載由協作學校及機構已填寫完成上述部份的完整表格",
    },
};

export default Form013TC;
